import { ConfigProvider, theme } from 'antd';
import { GridBackgroundLayout } from '@components/layout/GridBackgroundLayout';
import AppRouter from '@router/AppRouter';
import 'antd/dist/reset.css';
import '@styles/global.css';

function App() {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorBgContainer: 'rgba(11, 12, 15, 0.98)',
          colorBorder: 'rgba(112, 188, 255, 0.14)',
          colorPrimary: '#36d6ff',
          colorLink: '#9de8ff',
        },
      }}
    >
      <GridBackgroundLayout disableOnMobile>
        <AppRouter />
      </GridBackgroundLayout>
    </ConfigProvider>
  );
}

export default App;
